export enum SubscriptionType {
  FREE_TRIAL = 'freeTrial',
  PAID = 'paid',
  AFFILIATE = 'affiliate'
}

export interface ReferredTransporter {
  _id: string;
  name: string;
  lastName: string;
  email: string;
  companyName: string;
}

export interface ReferralStats {
  referralCode: string;
  referralCount: number;
  referredTransporters: ReferredTransporter[];
  isEligibleForReward: boolean;
  hasClaimedReward: boolean;
}

export interface Chapter {
  _id: string;
  name: string;
}

export interface Transporter {
  _id: string;
  name: string;
  lastName: string;
  assignment: string;
  email: string;
  phone: string;
  companyName: string;
  SIRETNumber: number;
  address: string;
  ZIPCode: number;
  country: string;
  creationDate: Date;
  password: string;
  startDate: Date;
  endDate: Date;
  isActive: boolean;
  subscriptionType: SubscriptionType;
  logo?: string;
  chapters: Chapter[];
  // Referral fields
  referralCode?: string;
  referredBy?: string;
  referredTransporters?: ReferredTransporter[];
  hasClaimedAffiliateReward?: boolean;
}
